<template>
  <b-tooltip
    v-if="!emailVerified"
    type="is-warning"
    :label="message"
    multilined
  >
    <b-button
      size="is-medium"
      type="is-warning"
      :loading="loading"
      :disabled="loading"
      icon-left="bell-ring"
      @click="sendEmail"
    />
  </b-tooltip>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('auth');

const message = 'Aún no has verificado tu correo electrónico, has click aquí para reenviar el email de confirmación.';

export default {
  name: 'AppButtonVerificationPending',
  data() { return { message, loading: false }; },
  computed: mapState({
    emailVerified: ({ emailVerified }) => emailVerified,
  }),
  methods: {
    async sendEmail() {
      this.loading = true;

      await this.$store.dispatch('auth/resendEmailVerification');

      this.loading = false;
    },
  },
};
</script>

<style scoped>
</style>
